import React from 'react';
import { View, TextInput, StyleSheet, TextInputProps } from 'react-native';
import { useTheme } from '../theme';

type TextAreaProps = {
  placeholder?: string;
  value: string;
  onChangeText: (t: string) => void;
  editable?: boolean;
  style?: any;
  disabledStyle?: any;
} & Partial<TextInputProps>;

const LhTextArea: React.FC<TextAreaProps> = ({
  placeholder,
  value,
  onChangeText,
  editable = true,
  style,
  disabledStyle,
  ...rest
}) => {
  const { colors, resolvedTheme } = useTheme();
  const isDark = resolvedTheme === 'dark';
  return (
    <View>
      <TextInput
        style={[
          styles.textarea,
          isDark && {
            backgroundColor: colors.input.background,
            borderColor: colors.input.border,
            color: colors.text.primary,
          },
          style,
          !editable && disabledStyle,
        ]}
        placeholder={placeholder}
        placeholderTextColor={isDark ? colors.text.disabled : "#B1B1B1"}
        value={value}
        onChangeText={onChangeText}
        multiline
        textAlignVertical="top"
        editable={editable}
        {...rest}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  textarea: {
    minHeight: 120,
    borderWidth: 1,
    borderColor: '#DADADA',
    borderRadius: 4,
    padding: 8,
    backgroundColor: '#FFFFFF',
    color: '#2D2D2D',
  },
});

export default LhTextArea;
